export default "/images/vendor/flag-icon-css/flags/4x3/ao.svg?ad6f3c8c3519f36b36c4cf46ebca2ab5";